import * as React from "react";
import BlinkHeader from "./BlinkHeader";
import AppWrapper from "./AppWrapper";
import { AuthorizationProvider } from "../authentication/AuthorizationContext";
import { QueryClient, QueryClientProvider } from "react-query";
import AxiosConfig from "../api/AxiosConfig";
import { LanguageProvider } from "../../common/i18n/i18n";

///* global, require */

export interface AppProps {
  title: string;
  isOfficeInitialized: boolean;
}

const App: React.FC<AppProps> = () => {
  const queryClient = new QueryClient();

  return (
    <AuthorizationProvider>
      <LanguageProvider>
        <AxiosConfig>
          <QueryClientProvider client={queryClient}>
            <BlinkHeader />
            <section className="blink-wrapper ms-bgColor-neutralLighterAlt">
              <AppWrapper />
            </section>
          </QueryClientProvider>
        </AxiosConfig>
      </LanguageProvider>
    </AuthorizationProvider>
  );
};

export default App;
